<template>
  <div>
    <slot></slot>

    <transition name="slide-up">
      <div>

        <fabric-color-selector class="mb-6"></fabric-color-selector>
        <texture-grid v-if="!meshIsAccessory(selectedMesh)" :items="textures"></texture-grid>

        <div v-else>
          <p>Design not available for this selection.</p>
        </div>

        <transition name="slide-up">
          <!--<texture-transform-selectors v-if="selectedMesh.id && !selectedMesh.name.includes('ACC_')"></texture-transform-selectors>-->
        </transition>
      </div>
    </transition>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  import FabricColorSelector from '../selectors/FabricColorSelector'
  // import TextureTransformSelectors from '../selectors/TextureTransformSelectors'
  import TextureGrid from '../partials/TextureGrid'


  export default {
    name: "TabTextures",
    components: {
      FabricColorSelector,
      // TextureTransformSelectors,
      TextureGrid
    },
    computed: {
      ...mapGetters('textures',[
        'textures',
        'selectedTexture'
      ]),
      ...mapGetters('clothes',[
        'selectedMesh'
      ]),
      ...mapGetters('objects3d',[
        'meshIsAccessory'
      ]),
    }
  }
</script>

<style scoped>
  /* Enter and leave animations can use different */
  /* durations and timing functions.              */
  .slide-up-enter-active {
    transition: all .6s ease-in-out;
  }
  .slide-up-leave-active {
    transition: all .6s ease-in-out;
  }
  .slide-up-enter, .slide-up-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateY(30px);
    opacity: 0;
  }

  .border-bottom {
    border-bottom: 1px solid #CAC8C8;
    padding-bottom: 20px;
  }
</style>